import React from 'react'
import { defineMessages, useIntl } from 'react-intl'

import { ConfirmationModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/confirmationModal/ConfirmationModal'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

export type AssessmentPendingModalProps = {
  clientName?: string
  onRequestClose: () => void
  visible: boolean
}

const MESSAGES = defineMessages({
  title: {
    defaultMessage: 'Assessment pending',
    description: 'Title of the modal shown for an assessment the client has not completed',
  },
  description: {
    defaultMessage: '{clientName} has not filled out this assessment yet, so there’s no data to display.',
    description: 'Explains that an assessment has no results because the client has not completed it',
  },
  clientFallback: {
    defaultMessage: 'This client',
    description: 'Fallback subject when the client’s name is unavailable in the pending assessment modal',
  },
  okay: {
    defaultMessage: 'Okay',
    description: 'Button that dismisses the pending assessment modal',
  },
})

export const AssessmentPendingModal: React.FC<AssessmentPendingModalProps> = ({
  clientName,
  onRequestClose,
  visible,
}) => {
  const { formatMessage } = useIntl()

  return (
    <ConfirmationModal
      visible={visible}
      closeOnScrim
      testID={tID('AssessmentPendingModal')}
      modalTitle={formatMessage(MESSAGES.title)}
      modalContents={formatMessage(MESSAGES.description, {
        clientName: clientName || formatMessage(MESSAGES.clientFallback),
      })}
      confirmationButtonText={formatMessage(MESSAGES.okay)}
      showCancel={false}
      onConfirmationButtonPress={onRequestClose}
      onRequestClose={onRequestClose}
    />
  )
}
